import { render, staticRenderFns } from "./SendContactWithFields.vue?vue&type=template&id=12e87c68&scoped=true&lang=pug"
import script from "./SendContactWithFields.vue?vue&type=script&lang=js"
export * from "./SendContactWithFields.vue?vue&type=script&lang=js"
import style0 from "./SendContactWithFields.vue?vue&type=style&index=0&id=12e87c68&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e87c68",
  null
  
)

export default component.exports